import { ContractOnboardingStrings } from "@/screen/Map/contractOnboarding.strings";

export interface ContractMapPlanStatus
{
    label: string;
    color: string;
}

const StatusColors =
{
    configuring: "#4A90D9",
    review: "#E8A838",
    notValidated: "#D96B6B",
    active: "#2E7D32",
    expired: "#908B8B",
    cancelled: "#5A5555",
    unknown: "transparent",
};

/**
 * Estado visual del plan de cartera según `currentStep` del onboarding.
 *
 * - 1.x / 2.x → En configuración
 * - 3.1 → En revisión
 * - 3.2 / 3.3 → No validado
 * - 4.1 → Activo
 * - 4.2 → Caducado
 * - 4.3 → Cancelado
 */
export function resolveContractMapPlanStatus(currentStep: string | null | undefined): ContractMapPlanStatus
{
    if(!currentStep)
    {
        return{
            label: ContractOnboardingStrings.planStatusUnknown,
            color: StatusColors.unknown,
        };
    }

    if(currentStep.startsWith("1") || currentStep.startsWith("2"))
    {
        return{
            label: ContractOnboardingStrings.planStatusConfiguring,
            color: StatusColors.configuring,
        };
    }

    if(currentStep === "3.1")
    {
        return{
            label: ContractOnboardingStrings.planStatusReview,
            color: StatusColors.review,
        };
    }

    if(currentStep === "3.2" || currentStep === "3.3")
    {
        return{
            label: ContractOnboardingStrings.planStatusNotValidated,
            color: StatusColors.notValidated,
        };
    }

    if(currentStep === "4.1")
    {
        return{
            label: ContractOnboardingStrings.planStatusActive,
            color: StatusColors.active,
        };
    }

    if(currentStep === "4.2")
    {
        return{
            label: ContractOnboardingStrings.planStatusExpired,
            color: StatusColors.expired,
        };
    }

    if(currentStep === "4.3")
    {
        return{
            label: ContractOnboardingStrings.planStatusCancelled,
            color: StatusColors.cancelled,
        };
    }

    return{
        label: ContractOnboardingStrings.planStatusUnknown,
        color: StatusColors.unknown,
    };
}